//送料について
const postageToggle = document.getElementsByClassName('postage__toggle');
if (postageToggle != "") {
	postageToggle[0].addEventListener('click', function () {
		this.classList.toggle('is-active');
		const answer = this.nextElementSibling;
		if (answer.style.maxHeight) {
			answer.style.maxHeight = null;
		} else {
			answer.style.maxHeight = answer.scrollHeight + "px";
		}
	});
};

//商品説明アコーディオン
const productDescriptionToggle = document.getElementsByClassName('productDescription__title');
if (productDescriptionToggle != "") {

	for (let i = 0; i < productDescriptionToggle.length; i++) {
		productDescriptionToggle[i].addEventListener('click', function () {
			this.classList.toggle('is-active');
			const answer = this.nextElementSibling;
			if (answer.style.display == "block") {
				//answer.style.maxHeight = null;
				answer.style.display = "none";
			} else {
				//answer.style.maxHeight = answer.scrollHeight + "px";
				answer.style.display = "block";
			}
		});
	}
	productDescriptionToggle[0].click();
};


//在庫表ポップアップ
const stocklistBtn = document.getElementById('stocklistBtn');
const cmorgClose = document.getElementById('cmorgClose');
const cmorg = document.getElementsByClassName('cmorg');
const cmorgBg = document.getElementsByClassName('cmorg__bg');

if (stocklistBtn != null) {
	stocklistBtn.addEventListener('click', function (e) {
		e.preventDefault();
		cmorg[0].classList.add('is-active');
	});


	cmorgClose.addEventListener('click', function (e) {
		cmorg[0].classList.remove('is-active');
	});
	cmorgBg[0].addEventListener('click', function (e) {
		cmorg[0].classList.remove('is-active');
	});
}


//定期ボタンが押されたら在庫表を非表示に
const body = document.body;
const stocklist = document.getElementsByClassName('stocklist');
body.addEventListener('click', function (e) {
	if (e.target.id == "subscription") {
		stocklist[0].style.display = "none";
	}
	if (e.target.id == "onetime") {
		stocklist[0].style.display = "block";
	}
});

//内容/成分
const seibun = document.getElementsByClassName('detail-tab_seibun');
if (seibun[0] != undefined) {
	const child = seibun[0].querySelectorAll('li');
	const target = seibun[0].querySelectorAll('.content_wrap');
	let headText = seibun[0].querySelectorAll('.component-type-headline');
	for (let i = 0; i < child.length; i++) {
		child[i].addEventListener('click', function () {
			//console.log("クリックしたのは" + i + "番目");
			//ボタン全非アクティブ
			for (let j = 0; j < child.length; j++) {
				child[j].classList.remove('component-type-current');
			}
			//一旦全非表示
			for (let k = 0; k < child.length; k++) {
				target[k].classList.add('disnon');
			}

			//見出しを変更
			let table = target[i].querySelector('table');
			let text = table.summary;
			headText[0].textContent = text;

			//ボタンをアクティブにして、コンテンツ表示
			child[i].classList.add('component-type-current');
			target[i].classList.remove('disnon');
		});
	}
}

// スマホ表示の際に各要素の位置を並び替え
document.addEventListener('DOMContentLoaded', function () {
	function moveShippingDateOnMobile() {
		// 移動対象の要素を取得
		const shippingDateElem = document.querySelector('.product-info__block-item[data-block-type="shippingDate"]'); // 出荷日
		const priceElem = document.querySelector('.product-info__block-item[data-block-type="price"]'); // 価格
		
		// 移動先の要素を取得
		const productForm = document.querySelector('form.shopify-product-form'); // カートに追加ボタン
		const quantitySelector = document.querySelector('.product-info__block-item[data-block-type="quantity-selector"]'); // 数量変更ボタン

		if (window.innerWidth <= 768) {
			// 出荷日要素をカートに追加ボタン下に移動
			if (shippingDateElem && productForm) {
				if (productForm.nextElementSibling !== shippingDateElem) {
					productForm.parentNode.insertBefore(shippingDateElem, productForm.nextSibling);
				}
				// only_sp_none クラスを外す
				shippingDateElem.classList.remove('only_sp_none');
			}

			// 価格要素を数量変更ボタン下に移動
			if (priceElem && quantitySelector) {
				if (quantitySelector.nextElementSibling !== priceElem) {
					quantitySelector.parentNode.insertBefore(priceElem, quantitySelector.nextSibling);
				}
				 // price-list を quantity-selector の子要素の最後に移動
        		const priceList = priceElem.querySelector('price-list');
        		if (priceList) {
					priceList.remove(); // 先に切り離す
          			quantitySelector.appendChild(priceList);
					priceList.querySelector('sale-price').style.fontSize = '1.1875rem';
					priceList.querySelector('sale-price').style.color = '#1A1A1A';
				}
				// only_sp_none クラスを外す
				priceElem.classList.remove('only_sp_none');
			}
		}
	}

	moveShippingDateOnMobile();
	window.addEventListener('resize', moveShippingDateOnMobile);
});